import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "game-shell" }
const _hoisted_2 = {
  class: "game-progress",
  "aria-labelledby": "game-progress-label"
}
const _hoisted_3 = { class: "game-progress__head" }
const _hoisted_4 = {
  id: "game-progress-label",
  class: "game-progress__label"
}
const _hoisted_5 = { class: "game-progress__track" }
const _hoisted_6 = { class: "game-hint" }
const _hoisted_7 = { class: "game-stage" }
const _hoisted_8 = { class: "game-viewport" }
const _hoisted_9 = { class: "swiper" }
const _hoisted_10 = { class: "swiper-wrapper" }
const _hoisted_11 = { class: "game-card__body" }
const _hoisted_12 = { class: "game-card__prompt" }
const _hoisted_13 = { class: "game-answer" }
const _hoisted_14 = {
  key: 0,
  class: "game-locked"
}
const _hoisted_15 = { class: "game-answer__input-row" }
const _hoisted_16 = ["aria-label", "onClick"]
const _hoisted_17 = { class: "game-footer" }
const _hoisted_18 = {
  key: 0,
  class: "visually-hidden"
}
const _hoisted_19 = {
  key: 0,
  class: "answer-feedback"
}
const _hoisted_20 = {
  class: "game-rail",
  "aria-label": "Words in this game"
}
const _hoisted_21 = ["aria-current", "aria-label", "onClick"]
const _hoisted_22 = {
  key: 0,
  class: "game-loading"
}
const _hoisted_23 = {
  key: 1,
  class: "game-empty"
}
const _hoisted_24 = { class: "info-sheet" }
const _hoisted_25 = { class: "completion-content" }
const _hoisted_26 = { class: "completion-stat__value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_firecracker_header = _resolveComponent("firecracker-header")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_lottie_animation = _resolveComponent("lottie-animation")!
  const _component_spinner = _resolveComponent("spinner")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_fun_icon = _resolveComponent("fun-icon")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_firecracker_header, {
        "header-title": "Guessing Word",
        "content-id": "guessing-game",
        "menu-id": "guessing-game-menu",
        type: "MENU"
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        id: "guessing-game"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _withDirectives(_createElementVNode("section", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("p", _hoisted_4, [
                  _cache[6] || (_cache[6] = _createTextVNode(" Word ", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.activeIndex + 1), 1),
                  _createTextVNode(" of " + _toDisplayString(_ctx.vocabularies.length), 1)
                ]),
                _createVNode(_component_ion_chip, {
                  class: "game-score",
                  "aria-label": `${_ctx.correctAnswerCount} correct out of ${_ctx.vocabularies.length}`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, {
                      icon: _ctx.correctIcon,
                      class: "firecracker-primary-color-icon game-score__icon",
                      "aria-hidden": "true"
                    }, null, 8, ["icon"]),
                    (_openBlock(), _createElementBlock("span", {
                      key: _ctx.scorePulseKey,
                      class: "game-score__value"
                    }, _toDisplayString(_ctx.correctAnswerCount), 1)),
                    _createElementVNode("span", null, "/ " + _toDisplayString(_ctx.vocabularies.length), 1)
                  ]),
                  _: 1
                }, 8, ["aria-label"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: "game-progress__fill",
                  style: _normalizeStyle({ width: `${_ctx.progressPercent}%` })
                }, null, 4)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[8] || (_cache[8] = _createElementVNode("span", null, "Read the meaning, then type the word.", -1)),
                _createVNode(_component_ion_button, {
                  class: "game-hint__link",
                  fill: "clear",
                  size: "small",
                  color: "primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isInfoModalOpened = true))
                }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode(" How it works ", -1)
                  ]))]),
                  _: 1
                })
              ])
            ], 512), [
              [_vShow, _ctx.showGame]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vocabularies, (vocabulary, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "swiper-slide"
                      }, [
                        _createElementVNode("div", _hoisted_11, [
                          _cache[9] || (_cache[9] = _createElementVNode("p", { class: "game-card__eyebrow" }, "Meaning", -1)),
                          _createElementVNode("p", _hoisted_12, _toDisplayString(vocabulary.meaning), 1)
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          (vocabulary.isCorrect)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: _ctx.correctIcon,
                                  "aria-hidden": "true"
                                }, null, 8, ["icon"]),
                                _createElementVNode("span", null, _toDisplayString(vocabulary.word), 1)
                              ]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("div", _hoisted_15, [
                                  _createVNode(_component_ion_textarea, {
                                    class: "game-answer__field",
                                    "aria-label": `Your answer for word ${index + 1}`,
                                    placeholder: "Type the word",
                                    inputmode: "text",
                                    enterkeyhint: "done",
                                    autocapitalize: "sentences",
                                    autocomplete: "off",
                                    autocorrect: "off",
                                    spellcheck: false,
                                    "auto-grow": true,
                                    rows: 1,
                                    value: _ctx.givenAnswers[index],
                                    onIonInput: ($event: any) => (_ctx.onGivingAnswer($event.detail.value as string, index)),
                                    onKeydown: _withKeys(_withModifiers(($event: any) => (_ctx.submitAnswer(vocabulary, index)), ["prevent"]), ["enter"])
                                  }, null, 8, ["aria-label", "value", "onIonInput", "onKeydown"]),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(["game-answer__clear", { 'game-answer__clear--hidden': !_ctx.hasDraft(index) }]),
                                    "aria-label": `Clear your answer for word ${index + 1}`,
                                    onPointerdown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                                    onClick: ($event: any) => (_ctx.clearAnswer(index))
                                  }, [
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: _ctx.clearIcon,
                                      "aria-hidden": "true"
                                    }, null, 8, ["icon"])
                                  ], 42, _hoisted_16)
                                ]),
                                _createVNode(_component_ion_button, {
                                  class: "game-answer__check",
                                  color: "primary",
                                  disabled: !_ctx.hasDraft(index),
                                  onClick: ($event: any) => (_ctx.submitAnswer(vocabulary, index))
                                }, {
                                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                    _createTextVNode(" Check ", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["disabled", "onClick"])
                              ], 64))
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("p", {
                            class: _normalizeClass(["game-feedback", _ctx.feedbackClass(vocabulary, index)]),
                            role: "status"
                          }, [
                            (vocabulary.isCorrect === true)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Correct!"))
                              : (_ctx.isRevealed(index))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: _ctx.infoIcon,
                                      "aria-hidden": "true"
                                    }, null, 8, ["icon"]),
                                    _createElementVNode("span", null, [
                                      _cache[11] || (_cache[11] = _createTextVNode("The word is ", -1)),
                                      _createElementVNode("strong", null, _toDisplayString(vocabulary.word), 1)
                                    ])
                                  ], 64))
                                : (vocabulary.isCorrect === false)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                      _createVNode(_component_font_awesome_icon, {
                                        icon: _ctx.incorrectIcon,
                                        "aria-hidden": "true"
                                      }, null, 8, ["icon"]),
                                      _createElementVNode("span", null, _toDisplayString(_ctx.failedMessage), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                          ], 2),
                          _createVNode(_component_ion_button, {
                            class: _normalizeClass(["game-reveal", { 'game-reveal--hidden': !_ctx.canReveal(vocabulary, index) }]),
                            fill: "clear",
                            size: "small",
                            color: "primary",
                            onClick: ($event: any) => (_ctx.reveal(index))
                          }, {
                            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                              _createTextVNode(" Show the answer ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["class", "onClick"])
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                (_ctx.hasAnswerFeedback)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      (_openBlock(), _createBlock(_component_lottie_animation, {
                        key: _ctx.answerFeedbackKey,
                        class: "answer-feedback__animation",
                        "animation-data": _ctx.answerFeedbackAnimation,
                        "primary-color-variable": 
                                    _ctx.isAnswerCorrect ? '--ion-color-primary' : '--ion-color-warning'
                                ,
                        "accent-color-variable": 
                                    _ctx.isAnswerCorrect ? '--ion-color-primary-tint' : '--ion-color-warning-tint'
                                ,
                        loop: false
                      }, null, 8, ["animation-data", "primary-color-variable", "accent-color-variable"]))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("nav", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vocabularies, (vocabulary, index) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: index,
                    type: "button",
                    class: _normalizeClass(["game-rail__step", _ctx.railClass(vocabulary, index)]),
                    "aria-current": index === _ctx.activeIndex ? 'step' : undefined,
                    "aria-label": `Word ${index + 1}: ${_ctx.railStateLabel(vocabulary, index)}`,
                    onClick: ($event: any) => (_ctx.goToSlide(index))
                  }, null, 10, _hoisted_21))
                }), 128))
              ])
            ], 512), [
              [_vShow, _ctx.showGame]
            ]),
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createVNode(_component_spinner, { "inline-style": "height: auto" }),
                  _createVNode(_component_ion_card_subtitle, {
                    class: "ion-text-center",
                    role: "status"
                  }, {
                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                      _createTextVNode(" Preparing the guessing game for today ... ", -1)
                    ]))]),
                    _: 1
                  })
                ]))
              : (!_ctx.vocabularies.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createVNode(_component_lottie_animation, {
                      class: "game-empty__art",
                      "animation-data": _ctx.funGameAnimation,
                      loop: true
                    }, {
                      fallback: _withCtx(() => [
                        _createVNode(_component_fun_icon, {
                          "fill-color-variable": '--ion-color-primary',
                          "stroke-color-variable": '--ion-color-primary'
                        })
                      ]),
                      _: 1
                    }, 8, ["animation-data"]),
                    _cache[15] || (_cache[15] = _createElementVNode("h2", { class: "game-empty__title" }, "Nothing to guess yet", -1)),
                    _cache[16] || (_cache[16] = _createElementVNode("p", { class: "game-empty__text" }, " Add a few words to your dictionary and a fresh guessing game will be waiting for you here. ", -1)),
                    _createVNode(_component_ion_button, {
                      color: "primary",
                      onClick: _ctx.goToAddVocabulary
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, {
                          icon: _ctx.plusIcon,
                          class: "ion-padding-end",
                          "aria-hidden": "true"
                        }, null, 8, ["icon"]),
                        _cache[14] || (_cache[14] = _createTextVNode(" Add a word ", -1))
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
            _createVNode(_component_ion_modal, {
              "aria-label": "How the daily game works",
              "is-open": _ctx.isInfoModalOpened,
              "initial-breakpoint": 0.4,
              breakpoints: [0, 0.4, 0.7, 0.9],
              onWillDismiss: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isInfoModalOpened = false))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_24, [
                  _cache[18] || (_cache[18] = _createElementVNode("h2", { class: "info-sheet__title" }, "How the daily game works", -1)),
                  _cache[19] || (_cache[19] = _createElementVNode("ul", { class: "info-sheet__list" }, [
                    _createElementVNode("li", null, "You are given a set of meanings. Type the word that matches each one."),
                    _createElementVNode("li", null, "Every correct guess adds to your score for the day."),
                    _createElementVNode("li", null, "Guess them all and you unlock another round today."),
                    _createElementVNode("li", null, "A brand new set is ready for you the next day.")
                  ], -1)),
                  _createVNode(_component_ion_button, {
                    color: "primary",
                    expand: "block",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isInfoModalOpened = false))
                  }, {
                    default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                      _createTextVNode("Got it", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["is-open"]),
            _createVNode(_component_ion_modal, {
              "aria-label": "All words guessed",
              "is-open": _ctx.isCompletionModalOpened,
              "initial-breakpoint": 0.6,
              breakpoints: [0, 0.6, 0.85, 1],
              onWillDismiss: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isCompletionModalOpened = false))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_lottie_animation, {
                    class: "completion-animation",
                    "animation-data": _ctx.gameCompleteAnimation,
                    loop: true
                  }, {
                    fallback: _withCtx(() => [
                      _createVNode(_component_fun_icon, {
                        "fill-color-variable": '--ion-color-primary',
                        "stroke-color-variable": '--ion-color-primary'
                      })
                    ]),
                    _: 1
                  }, 8, ["animation-data"]),
                  _cache[21] || (_cache[21] = _createElementVNode("h2", { class: "completion-title" }, "All words guessed!", -1)),
                  _cache[22] || (_cache[22] = _createElementVNode("p", { class: "completion-text" }, "Well done, you nailed every word in today's round.", -1)),
                  _createVNode(_component_ion_chip, { class: "completion-stat" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.correctAnswerCount), 1),
                      _createElementVNode("span", null, "of " + _toDisplayString(_ctx.vocabularies.length) + " correct", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_button, {
                    color: "primary",
                    expand: "block",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isCompletionModalOpened = false))
                  }, {
                    default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                      _createTextVNode(" Close ", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["is-open"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}